import React from "react";
const SvgPoiRecharge = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FF8703"
        d="M24 12c0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12S5.372 0 12 0c6.627 0 12 5.373 12 12"
      />
      <path
        fill="#FFF"
        d="M18.226 6.218a.38.38 0 01.387.376v.808c.214.001.387.17.387.376v.659c0 .615-.429 1.13-1.01 1.295v4.035c0 .796-.67 1.445-1.494 1.445s-1.494-.649-1.494-1.445v-1.629a.684.684 0 00-.33-.576v4.773l.605 1.114a.366.366 0 01-.012.37.393.393 0 01-.334.181H6.388a.394.394 0 01-.332-.18.366.366 0 01-.011-.37l.605-1.117V7.658h8.023v3.082c.635.166 1.106.724 1.106 1.391v1.636c0 .382.322.693.717.693.395 0 .716-.31.716-.693V9.732c-.582-.165-1.011-.68-1.011-1.295v-.659c0-.207.173-.375.387-.376v-.808a.38.38 0 01.387-.376c.215 0 .39.167.39.376v.808h.47v-.808c0-.209.176-.376.39-.376zm-6.917 2.526a.29.29 0 00-.345.138l-1.95 3.778a.26.26 0 00.013.267c.05.08.142.13.24.13h1.11v2.155a.276.276 0 00.284.274.284.284 0 00.261-.17l1.394-3.238a.269.269 0 00-.026-.257.287.287 0 00-.236-.122H11l.495-2.645a.273.273 0 00-.186-.31zM13.097 5c.87 0 1.575.684 1.575 1.525v.578H6.65v-.578C6.65 5.685 7.356 5 8.224 5z"
      />
    </g>
  </svg>
);
export default SvgPoiRecharge;
